<template>
  <div id="app">
    <svgList />
    <router-view />
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      :close-on-click-modal="!isSelectingIdentity"
      :close-on-press-escape="!isSelectingIdentity"
      @close="handleClose"
      :show-close="false"
      width='444px'
      class="login_dialog"
    >
      <loginDialogPage />
    </el-dialog>
    <!-- <loginDIalog /> --> 
  </div>
</template>
<script>
import loginDIalog from "@/components/loginDIalog";
import loginDialogPage from "@/views/loginDialogPage";
import { setCookie, getCookie } from "@/utils/cookie";
import svgList from "@/components/svgList";
import { getUserInfo } from "@/api/user.js";
import { domainName } from "@/utils/domainName";

export default {
  components: {
    loginDIalog,
    svgList,
    loginDialogPage
  },
  data() {
    return {
      loginDisplay: this.$store.state.loginDisplay,//
      dialogVisible: false
    };
  },
  computed: {
    setLoginDisplay() {
      return this.$store.state.loginDisplay
    },
    isSelectingIdentity() {
      // 业务意图：拿到双 Token 仅表示用户已认证；未确认身份前不能进入工作台或中断身份选择。
      return Boolean(getCookie("login_token")) && !this.$store.state.userIdentity
    },
  },
  watch: {
    setLoginDisplay: function (data) {
      this.loginDisplay = data
      this.init()
    }
  },
  mounted() {
    // 跨站双 Token 到达后，由登录组件在后台查询身份。
    // 只有多个身份、需要补充信息或需要展示公告时才打开弹窗，避免单身份用户看到过渡页。
    document.addEventListener('keydown', function (e) {
      if (e.key == 'Escape' || e.keyCode == 27) {
        e.stopImmediatePropagation(); // 阻止其他监听器
        e.preventDefault();           // 阻止默认行为（如关闭弹出层或返回上一页）
      }
    }, true);
    // partner_uuid 渠道id
    // activation_id 激活
    // invitation_id 邀请
    const queryParams =  window.location.href.indexOf('?') == -1 ? {} : this.getQueryParams(); //地址栏参数

    let getparams = getCookie('queryParams') ? JSON.parse(getCookie('queryParams')) : sessionStorage.getItem('queryParams') ? JSON.parse(sessionStorage.getItem('queryParams')) : {} //cookie
  
    if (queryParams.iframes) { //支付弹窗/地址栏有参数iframes   
      getparams.iframes = queryParams.iframes
      setCookie('queryParams', JSON.stringify(getparams))
    } else {
      delete queryParams.iframes
      if (Object.keys(queryParams).length != 0) { //地址栏有参数
        setCookie('queryParams', JSON.stringify(queryParams))
      } else if (getparams&&(getparams.partner_uuid || getparams.activation_id)) { //cookie有
        setCookie('queryParams', JSON.stringify(getparams))
        // return
      }
    }
    //根据不同路由跳转不同页面
    if (this.isMobile()) {
      // console.log("手机端")
      if (queryParams.iframes || queryParams.source_login) {
        return
      } else {
        // 初始化基础路径
        let redirectUrl = domainName.api10 + '/indexview';
        // 创建一个数组来存储查询参数
        let queryParamsArray = [];
        // 遍历 queryParams 对象，将存在的字段拼接到 URL 中
        for (let key in queryParams) {
          if (queryParams.hasOwnProperty(key) && queryParams[key] !== undefined && queryParams[key] !== null) {
            queryParamsArray.push(`${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`);
          }
        }
        // 如果有查询参数，则拼接到 URL 后面
        if (queryParamsArray.length > 0) {
          redirectUrl += '?' + queryParamsArray.join('&');
        }
        // 跳转到生成的 URL
        window.location.replace(redirectUrl);
        return

      }
  
    } else {
      // console.log("PC端")
    }


  },
  methods: {
    init() {
      if (this.loginDisplay) {
        this.dialogVisible = true
      } else {
        this.dialogVisible = false
      }
    },
    
    handleClose() {
      if (this.isSelectingIdentity) {
        // 兜底处理：即使弹窗被其它代码请求关闭，待选择身份时仍必须留在身份选择流程。
        this.dialogVisible = true
        this.$store.commit("setLoginDisplay", true);
        return
      }

      this.dialogVisible = false
      this.$store.commit("setLoginDisplay", false);
    },
    // url 参数
    getQueryParams() {
      const queryStr = window.location.href.split('?')[1]; // 去掉开头的 "?"
      const params = queryStr.split('&').reduce((acc, item) => {
        const [key, value] = item.split('=');
        acc[decodeURIComponent(key)] = decodeURIComponent(value);
        return acc;
      }, {});

      return params;
    },
    //该方法用于判断是否进入手机端
    isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    },
  }
};
</script>
<style lang="css">
::-webkit-scrollbar {
  width: 3px;
}

::-webkit-scrollbar-thumb {
  border-radius: 8px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #dcd9d9;
}

::-webkit-scrollbar-thumb:hover {
  background: #333333;
}

.el-message {
  /* min-width: auto !important; */
  min-width: max-content !important;
}
</style>

<style scoped>
.login_dialog /deep/ .el-dialog__headerbtn {
  z-index: 100;
}
.login_dialog /deep/ .el-dialog {
  border-radius: 30px;
}
.login_dialog /deep/ .el-dialog__header {
  padding: 0;
}
.login_dialog /deep/ .el-dialog__body {
  padding: 0;
}
</style>
